import { WarningIcon } from "@chakra-ui/icons";
import {
  Box,
  chakra,
  Text,
  Button,
  Flex,
  Avatar,
  Link,
  FormLabel,
  ModalHeader,
  Image,
  HStack,
  Input,
  ModalContent,
  Badge,
} from "@chakra-ui/react";
import "@fontsource/poppins";
export const PasswordChangedModalContainer = chakra(Box, {
  baseStyle: {
    background: "#FFF",
    borderRadius: "20px",
    padding: "40px 24px",
    maxWidth: "420px",
    w: "100%",
    textAlign: "center",
    boxShadow: `
      0px 3px 11px 0px rgba(24, 25, 180, 0.06),
      0px 10px 18px 0px rgba(24, 25, 180, 0.06)
    `,
  },
});

export const PasswordChangedHeading = chakra(Text, {
  baseStyle: {
    color: "#111827",
    fontSize: "16px",
    fontWeight: "700",
    fontFamily: "Poppins",
    mb: "10px",
  },
});

export const PasswordChangedSubtext = chakra(Text, {
  baseStyle: {
    fontSize: "16px",
    color: "#5C6670",
    fontWeight: "15px",
    fontFamily: "Poppins",
    mb: "24px",
  },
});

export const ContinueLoginButton = chakra(Button, {
  baseStyle: {
    w: "100%",
    h: "44px",
    bg: "#1819B4",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    fontFamily: "Poppins",
    borderRadius: "8px",
    _hover: {
      bg: "#1516A0",
    },
  },
});
export const ProfileContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    pt: { base: "6", md: "12" },
    px: { base: "4", md: "8" },
    w: "100%",
    minH: "100vh",
    bg: "white",
  },
});

export const ProfileAvatar = chakra(Avatar, {
  baseStyle: {
    boxSize: { base: "100px", md: "120px" },
    mt: "80%",
  },
});

export const ProfileUsername = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 500,
    color: "#798692",
  },
});

export const UpdateProfileButton = chakra(Button, {
  baseStyle: {
    w: "129px",
    h: "45px",
    pt: "12px",
    pr: "16px",
    pb: "12px",
    pl: "14px",
    fontFamily: "Poppins",
    gap: "4px", // applies if there's an icon/text spacing
    borderRadius: "8px",
    borderWidth: "1px",
    bg: "#1819B4",
    color: "white",
    fontSize: "14px",
    fontWeight: 500,
    _hover: { bg: "#0f109e" },
  },
});

export const MyProfileHeading = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    display: "inline",
    fontWeight: 600,
    fontSize: "24px",
    color: "#111827",
    textAlign: "left",
    alignSelf: "flex-start",
    mb: "8px",
    top: "0",
  },
});
export const ChangeHistory = chakra(Button, {
  baseStyle: {
    fontFamily: "Poppins",
    display: "inline",
    height: "33px",
    fontWeight: 500,
    fontSize: "14px",
    color: "#1819B4",
    textAlign: "center",
    borderRadius: "8px",
    alignSelf: "flex-end",
    outline: "#1819B4",
    border: "1px",
    mb: "8px",
    top: "0",
    bg: "#FFFFFF",
  },
});

export const MyProfileSubtext = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    color: "#798692",
    textAlign: "left",
    alignSelf: "flex-start",
    mb: "20px",
    mt: "0px",
  },
});

export const ProfileLabel = chakra(FormLabel, {
  baseStyle: {
    fontSize: "16px",
    color: "#2F2F34",
    fontFamily: "Poppins",
    fontWeight: "600px",
  },
});

export const PasswordChangeLink = chakra(Link, {
  baseStyle: {
    color: "#0073E0",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Poppins",
    cursor: "pointer",
    mt: 2,
  },
});

export const SaveButton = chakra(Button, {
  baseStyle: {
    width: "133px",
    height: "45px",
    fontFamily: "Poppins",
    fontWeight: "500",
    color: "#FFFFFF",
    bg: "#1819B4",
  },
});
export const ProfileWrapper = chakra(Flex, {
  baseStyle: {
    direction: "column",

    h: "100%",
    w: "100%",
    p: { base: 4, md: 10 },
    pb: "100px",
    bg: "#FFFFFF",
  },
});

export const StyledModalHeader = chakra(ModalHeader, {
  baseStyle: {
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Poppins",
    fontSize: "20px",
    mb: -2,
  },
});

export const Subtext = chakra(Text, {
  baseStyle: {
    textAlign: "center",
    fontSize: "14px",
    fontFamily: "Poppins",
    color: "#6B7280",
    mb: 6,
  },
});

export const PasswordHint = chakra(Text, {
  baseStyle: {
    fontSize: "12px",
    fontFamily: "Poppins",
    color: "gray.500",
    mt: 1,
  },
});

export const ToggleButton = chakra(Button, {
  baseStyle: {
    variant: "ghost",
    height: "20px",
    width: "12px",
    bg: "#FFFFFF",
  },
});

export const ResetPasswordButton = chakra(Button, {
  baseStyle: {
    w: "100%",
    bg: "#1819B4",
    color: "white",
    fontFamily: "Poppins",
    fontWeight: "bold",
    borderRadius: "10px",
    _hover: { bg: "#A996F8" },
  },
});

export const StyledFormLabel = chakra(FormLabel, {
  baseStyle: {
    fontWeight: "500",
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#2F2F34",
  },
});

export const CourseDescContainer = chakra(Box, {
  baseStyle: {
    width: "100%",
    maxW: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    h: "100%",
  },
});

export const CourseDescText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: { base: "14px", md: "16px" },
    lineHeight: "100%",
    color: "#2F2F34",
  },
});

export const CourseMetaInfo = chakra(Flex, {
  baseStyle: {
    align: "center",
    gap: "8px",
    mt: "12px",
    flexWrap: "wrap",
    fontFamily: "Poppins",
    color: "#5C6670",
    fontWeight: 400,
    fontSize: { base: "12px", md: "14px" },
    lineHeight: "100%",
  },
});

export const CourseProgressWrapper = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    width: "100%",
    mt: "12px",
  },
});

export const CourseProgressText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    alignSelf: "flex-end",
    color: "#2F2F34",
    fontSize: { base: "12px", md: "14px" },
    mb: "8px",
  },
});
export const CompletedCourseContainer = chakra(Flex, {
  baseStyle: {
    width: ["100%", "100%", "100%"], // Full width on mobile/tablet, fixed width on desktop
    height: ["auto", "auto", "122px"], // Adjust height responsively if needed
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: ["center", "flex-start"], // Center items on mobile, align left on larger screens
    padding: ["16px", "20px"], // Optional padding for better spacing
    borderRadius: "12px", // Optional for nicer visuals
    gap: "8px", // Space between items
  },
});

export const CompletedCourseTitle = chakra(Text, {
  baseStyle: {
    fontWeight: 600,
    fontSize: ["14px", "16px"],
    color: "#2F2F34",
  },
});

export const CompletionDateText = chakra(Text, {
  baseStyle: {
    fontSize: ["12px", "14px"],
    color: "#5C6670",
    fontWeight: 400,
    fontFamily: "Poppins",
  },
});

export const IssuedButton = chakra(Button, {
  baseStyle: {
    width: "56px",
    height: "22px",
    pt: "2px",
    pr: "8px",
    pb: "2px",
    pl: "8px",
    borderRadius: "16px",
    borderWidth: "0.5px",
    fontSize: "12px",
    fontWeight: 500,
    fontFamily: "Poppins",
    variant: "outline",
    bg: "#00A1770F",
    color: "#00A177",
    borderColor: "#00A177",
  },
});

export const CompletedCourseWrapper = chakra(Flex, {
  baseStyle: {
    w: ["100%", "100%"],
    h: "auto",
    gap: ["16px", "40px"],
    borderRadius: "12px",
    borderWidth: "1px",
    padding: ["12px", "16px"],
    flexDirection: ["column", "row"],
    justifyContent: "space-between",
    borderColor: "#CDD6DC",
  },
});

export const CourseImageBox = chakra(Box, {
  baseStyle: {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
export const CourseActionsWrapper = chakra(Flex, {
  baseStyle: {
    flexDirection: { base: "column", md: "row" },
    width: "100%",
    flexWrap: "wrap",
    height: "auto",
    justifyContent: { base: "center", md: "flex-end" },
    alignItems: { base: "stretch", md: "center" },
    gap: { base: "10px", md: "24px" },
    padding: { base: "12px", md: "16px" },
  },
});

export const RewatchButton = chakra(Button, {
  baseStyle: {
    width: { base: "100%", sm: "150px", md: "118px" },
    height: "36px",
    px: "12px",
    py: "6px",
    gap: "4px",
    borderRadius: "8px",
    borderWidth: "1px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    color: "#1819B4",
    borderColor: "#1819B4",
    variant: "outline",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bg: "#FFFFFF",
  },
});

export const AvatarEditWrapper = chakra(Box, {
  baseStyle: {
    position: "relative",
    display: "inline-block",
  },
});

export const EditIconWrapper = chakra(Box, {
  baseStyle: {
    position: "absolute",
    bottom: "4px",
    right: "4px",
    width: "32px",
    height: "32px",
    backgroundColor: "#344054",
    borderRadius: "full",
    padding: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 1,
    boxShadow: "sm",
  },
});

export const EmailVerifyWrapper = chakra(Box, {
  baseStyle: {
    padding: "32px 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
});

export const EmailVerifyIconCircle = chakra(Box, {
  baseStyle: {
    width: "56px",
    height: "56px",
    borderRadius: "full",
    backgroundColor: "#FEF3C7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
  },
});

export const EmailVerifyIcon = chakra(WarningIcon, {
  baseStyle: {
    color: "#F59E0B",
    fontSize: "24px",
  },
});

export const EmailVerifyHeading = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "18px",
    color: "#1F2937",
    marginBottom: "12px",
  },
});

export const EmailVerifyText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    color: "#4B5563",
    marginBottom: "24px",
  },
});

export const VerifyButton = chakra(Button, {
  baseStyle: {
    backgroundColor: "#1819B4",
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    borderRadius: "8px",
    padding: "10px 20px",
    _hover: {
      backgroundColor: "#0F118E",
    },
  },
});

export const CertificateButton = chakra(Button, {
  baseStyle: {
    width: { base: "100%", sm: "220px", md: "201px" },
    height: "36px",
    px: "12px",
    py: "6px",
    gap: "4px",
    borderRadius: "8px",
    borderWidth: "1px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    color: "#FFFFFF",
    borderColor: "#1819B4",
    variant: "outline",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bg: "#1819B4",
  },
});
export const StyledModalContent = chakra(ModalContent, {
  baseStyle: {
    bg: "white",
    borderRadius: "16px",
    p: 6,
    maxW: "632px",
    maxH: "418px",
    textAlign: "center",
  },
});

export const OtpInputBox = chakra(HStack, {
  baseStyle: {
    gap: "12px",
    mb: 4,
  },
});

export const StyledInput = chakra(Input, {
  baseStyle: {
    width: "80px",
    height: "80px",
    textAlign: "center",
    fontSize: "48px",
    fontWeight: 500,
    color: "#1819B4",
    border: "2px solid #D1D5DB",
    borderRadius: "8px",
    _focus: {
      borderColor: "#3B82F6",
      boxShadow: "0 0 0 1px #3B82F6",
    },
    _invalid: {
      border: "1px solid red",
      color: "red",
      _focus: {
        borderColor: "red",
      },
    },
  },
});

export const StyledVerifyButton = chakra(Button, {
  baseStyle: {
    width: "100%",
    height: "60px",
    borderEndRadius: "16px",
    bg: "#1819B4",
    color: "white",
    fontSize: "14px",
    fontWeight: 500,
    mt: 4,
    borderRadius: "8px",
    fontFamily: "Poppins",
    _hover: {
      bg: "#0F1090",
    },
  },
});

export const ResendText = chakra(Text, {
  baseStyle: {
    fontSize: "14px",
    color: "#5C6670",
    fontWeight: "400",
    mb: 2,
  },
});
export const DashSeparator = chakra("span", {
  baseStyle: {
    fontSize: "24px",
    color: "#2F2F34",
    mx: "4px",
    fontWeight: "600",
  },
});

export const ResendClickableText = chakra(Text, {
  baseStyle: {
    display: "inline",
    color: "#1819B4",
    fontWeight: "bold",
    cursor: "pointer",
  },
});

export const TestEmail = chakra(Text, {
  baseStyle: {
    fontWeight: "400px",
    fontsize: "16px",
    color: "#5C6670",
  },
});

export const DrawerContainer = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100%",
  width: "920px",
  flexDirection: "column",
  bg: "white",
  boxShadow: "2xl",
  borderTopLeftRadius: "2xl",
  borderBottomLeftRadius: "2xl",
  zIndex: 1400,
  p: 6,
  overflowY: "auto",
} as const;

export const DrawerHeader = {
  justify: "space-between",
  align: "flex-start",
  mb: 4,
} as const;

export const CourseTitleSection = {
  align: "center",
  gap: 3,
} as const;

export const CompletionBadge = {
  fontSize: "12px",
  fontWeight: "600",
  bg: "#3538CD",
  color: "#FFFFFF",
  height: "22px",
  px: 3,
  borderRadius: "full",
  align: "center",
  justify: "center",
} as const;

export const DrawerClose = {
  fontSize: "xl",
  color: "gray.500",
  cursor: "pointer",
} as const;

export const DownloadButton = {
  as: "button",
  fontSize: "14px",
  h: "38px",
  px: 4,
  py: 2,
  bg: "#FFFFFF",
  color: "#1819B4",
  border: "1px solid #1819B4",
  borderRadius: "8px",
  fontWeight: "500",
  _hover: { bg: "#A7B2BA" },
} as const;

export const EnrolledCard = {
  justify: "space-between",
  m: 2,
  p: 3,
  border: "1px solid #F1F1F1",
  borderRadius: "16px",
  align: "flex-start",
} as const;

export const AvatarBox = {
  w: "36px",
  h: "36px",
  borderRadius: "full",
  overflow: "hidden",
  bg: "gray.100",
  flexShrink: 0,
} as const;

export const ProgressBackground = {
  h: "6px",
  bg: "#E5E7EB",
  borderRadius: "md",
  overflow: "hidden",
} as const;

export const ProgressFill = (progress: number) => ({
  h: "6px",
  bg: "#0073E0",
  width: `${progress}%`,
});

export const CertificateWrapper = chakra(Flex, {
  baseStyle: {
    w: "100%",
    h: "154px",
    gap: "20px",
    borderRadius: "12px",
    borderWidth: "1px",
    p: "16px",
    flexDirection: "row",
    justifyContent: "flex-start",
    borderColor: "#CDD6DC",
    flexWrap: ["wrap", "nowrap"],
  },
});

export const CourseImage = chakra(Image, {
  baseStyle: {
    borderRadius: "9px",
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
});

export const ButtonWrapper = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    w: "100%",
  },
});

export const DownloadCertificateButton = chakra(Button, {
  baseStyle: {
    fontFamily: "Poppins",
    fontSize: ["13px", "14px"],
    fontWeight: 500,
    maxW: "205px",
    w: ["100%", "fit-content"],
    h: "36px",
    px: ["12px", "16px"],
    py: "6px",
    gap: "4px",
    borderRadius: "8px",
    borderWidth: "1px",
    color: "#FFFFFF",
    borderColor: "#1819B4",
    variant: "outline",
    bg: "#1819B4",
  },
});

export const RespondButton = chakra(Button, {
  baseStyle: {
    variant: "outline",
    fontWeight: "bold",
    bg: "#1819B4",
    color: "#FFFFFF",
    w: "132px",
    maxW: "fit-content",
    h: "44px",
    borderRadius: "8px",
    px: 6,
    _hover: {
      bg: "#15168f",
    },
  },
});

export const EnrollButton = chakra(Button, {
  baseStyle: {
    variant: "outline",
    borderColor: "#1819B4",
    color: "#1819B4",
    bg: "#FFFFFF",
    fontWeight: "500",
    fontSize: "14px",
    w: "63px",
    h: "34px",
    px: "12px",
    py: "2px",
    borderRadius: "8px",
    borderWidth: "1px",
    gap: "10px",
    fontFamily: "Poppins",
  },
});

export const RquirementLabel = chakra(Badge, {
  baseStyle: {
    position: "absolute",
    top: "12px",
    right: "8px",
    zIndex: 0,
    bg: "#FFFFFF",
    borderRadius: "16px",
    px: "8px",
    py: "2px",
    fontSize: "12px",
    fontWeight: "500",
  },
});

export const ImageCourse = chakra("img", {
  baseStyle: {
    alt: "Course image",
    loading: "lazy",
    w: "100%",
    h: "100%",
    objectFit: "contain",
    borderRadius: "16px",
    transition: "opacity 0.2s",
  },
});
export const ViewAnswerButton = chakra(Button, {
  baseStyle: {
    variant: "outline",
    fontWeight: "semibold",
    fontSize: "14px",
    bg: "#FFFFFF",
    color: "#1819B4",
    border: "1px solid",
    borderColor: "#1819B4",
    w: "123px",
    maxW: "fit-content",
    h: "44px",
    borderRadius: "8px",
    px: 6,
    _hover: {
      bg: "#1819B4",
      color: "#FFFFFF",
    },
  },
});

export const StatusLabel = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "medium",
    px: "2",
    py: "1",
    bg: "#5C66701A",
    h: "fit-content",
    w: "fit-content",
    borderRadius: "16px",
    color: "#5C6670",
  },
});

export const FaqHeaderWrapper = chakra(Flex, {
  baseStyle: {
    w: "100%",
    maxW: "1190px",
    fontWeight: "semibold",
    fontSize: "24px",
    mt: "26px",
    h: "68px",
    align: "center",
    justify: "space-between",
    borderRadius: "8px",
    bg: "white",
  },
});
